class Header {
  header = document.querySelector('.header');
  scroll = Math.abs(window.scrollY);

  constructor() {
    this.handleScroll();
    window.addEventListener('scroll', () => this.handleScroll());
  }

  handleScroll() {
    if (window.scrollY > this.scroll && window.scrollY > this.header.getBoundingClientRect().height) {
      this.header.classList.add('hidden');
    } else {
      this.header.classList.remove('hidden');
    }

    this.scroll = Math.abs(window.scrollY);
  }
}

export default Header;
